export const POPUP_SELL_ITEM_TYPE = {
  create: 'create',
  edit: 'edit'
};
